import Lista from './Lista';

export const CurriculoLista = Lista;
